import type { ILeaderRecord } from "../../../store/slices/battingPractice";

interface LeaderboardProps {
  label: string;
  records: ILeaderRecord[];
  units: string;
}

export const Leaderboard = ({ label, records, units }: LeaderboardProps) => {
  return (
    <div className="flex flex-col gap-1 rounded bg-white px-4 py-2 shadow-md">
      <h3 className="text-center text-base font-semibold text-charcoal-900">
        {label}
      </h3>
      {[0, 1, 2].map((index) => {
        const record = records[index];
        return (
          <div key={index} className="flex items-center justify-between">
            <span className="text-base text-text-light">
              {record ? record.playerName : "---"}
            </span>
            <div className="flex flex-col items-end">
              <span className="text-[22px] font-semibold text-charcoal-900">
                {record ? record.value.toFixed(1) : "---"}
              </span>
              <span className="-mt-1 text-xs text-text-light">{units}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
